// extracted by mini-css-extract-plugin
module.exports = {"button":"keranjang_button__2oZB1","icon":"keranjang_icon__1n9AD","linkss":"keranjang_linkss__24-3f","badge":"keranjang_badge__3wWzY","bump":"keranjang_bump__3QX0H"};